// extracted by mini-css-extract-plugin
export default {"viewBox":"SuperAdminHelp_viewBox__QhCOS"};